import { render, staticRenderFns } from "./ourProducts.vue?vue&type=template&id=89ccfe88&scoped=true&"
var script = {}
import style0 from "./ourProducts.vue?vue&type=style&index=0&id=89ccfe88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ccfe88",
  null
  
)

export default component.exports